// extracted by mini-css-extract-plugin
export var connectionButton = "_bu-1";
export var connectionButtonFloating = "_bu-2";
export var connectionContainer = "_bu-0";
export var rightPanel = "_bu-6";
export var stepCard = "_bu-3";
export var stepCardSubtitle = "_bu-5";
export var stepCardText = "_bu-4";